module.exports = __webpack_public_path__ + "img/send.54e3dca5.svg";